module.exports = __webpack_public_path__ + "static/media/255-brazil.f73f4e14.svg";